import {isChild, isRowType, groupMediaItems, denormalizeRowItems, stipFieldsForDiff} from './helpers'

export default {
  moveModal (state) {
    return state.modals.move
  },

  index (state) {
    return state.index.ids.map((id) => state.index.rows[id])
  },

  byTopic (state, getters, rootState) {
    return getters.index.filter((item) => {
      return item.topic.id === rootState.topics.current.id
    })
  },

  editing (state) {
    return state.editing.ids.map((id) => state.editing.rows[id])
  },

  children (state) {
    return ({id, editing = true} = {}) => {
      if (editing) {
        return state.editing.rows[id].children.map((id) => state.editing.children[id])
      } else {
        return state.index.rows[id].children.map((id) => state.index.children[id])
      }
    }
  },

  byID (state, getters) {
    return ({id, level = 0} = {}) => {
      if (isChild({state, id})) {
        return state.editing.children[id]
      } else {
        return state.editing.rows[id]
      }
    }
  },

  rowNumber (state, getters) {
    return ({rowID, editing}) => {
      let items = []
      if (editing) {
        items = getters.editing
      } else {
        items = getters.byTopic
      }

      const rows = items.filter((item) => {
        // only rows that are procedures have numbers
        return isRowType(item) && Number(item.is_procedure) === 1
      }).map(item => item.id)

      return rows.indexOf(rowID) + 1
    }
  },

  canMove (state, getters) {
    return ({item, direction}) => {
      if (state.saving || state.fetching) {
        return false
      }

      let order = []
      let idx = null

      // row child
      if (item.parentID) {
        order = state.editing.rows[item.parentID].children
        idx = order.indexOf(item.id)

      // row
      } else {
        order = state.editing.ids
        idx = order.indexOf(item.id)
      }

      if (direction === 'up') {
        return idx > 0
      } else if (direction === 'down') {
        return idx < order.length - 1
      }
    }
  },

  // format data for client display
  forClient (state, getters) {
    return (isPreview) => {

      let items = []
      if (isPreview) {
        items = denormalizeRowItems({state, items: getters.editing, editing: true})
      } else {
        items = denormalizeRowItems({state, items: getters.byTopic, editing: false})
      }

      let itemsForClient = []

      // group media items at the row level
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (item.type === 'row') {
          item.children = groupMediaItems(item.children)
        }
        itemsForClient.push(item)
      }

      // group media items at the top level
      itemsForClient = groupMediaItems(itemsForClient)

      return itemsForClient
    }
  },

  isOddRow (state, getters) {
    return (itemID) => {
      const items = getters.byTopic
      let rowCount = 0

      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (isRowType(item)) {
          rowCount++
        }

        if (item.id === itemID) {
          return rowCount % 2 === 1
        }
      }
    }
  },

  unsavedChanges (state, getters) {
    let editing = denormalizeRowItems({state, items: getters.editing, editing: true})
    let byTopic = denormalizeRowItems({state, items: getters.byTopic, editing: false})

    editing = stipFieldsForDiff(editing)
    byTopic = stipFieldsForDiff(byTopic)

    return JSON.stringify(editing) !== JSON.stringify(byTopic)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/items/getters.js